<template>
  <modal :show="show" :max-width="maxWidth" :BlurClass="BlurClass" :persistent-message="persistentMessage"
    :closeable="closeable" :main-class="mainClass" :header-class="headerClass" :extra-flex="extraFlex"
    :extra-class="extraClass" :footer-color="footerColor" @close="close">
    <div class="px-6 py-4" :class="headerClass">
      <div class="text-lg">
        <slot name="header" />
      </div>

      <div class="mt-4" :class="mainClass">
        <slot name="content" />
      </div>
    </div>

    <div v-if="$slots.footer" class="px-6 py-4 bg-gray-100 text-right" :class="footerColor">
      <slot name="footer" />
    </div>
  </modal>
</template>

<script>
import Modal from './Modal.vue';

export default {

  components: {
    Modal,
  },

  props: {
    show: {
      default: false
    },
    headerClass: {
      default: '',
      require: false
    },
    maxWidth: {
      default: '2xl'
    },
    closeable: {
      default: true
    },
    persistentMessage: {
      default: '',
      require: false
    },
    extraClass: {
      default: '',
      require: false
    },
    mainClass: {
      default: '',
      require: false
    },
    footerColor: {
      default: '',
      require: false
    },
    extraFlex: {
      default: '',
      require: false
    },
    BlurClass: {
      default: '',
      require: false
    }
  },
  emits: ['close'],

  methods: {
    close() {
      this.$emit('close')
    },
  }
}
</script>
<style scoped>
.modal-padding {
  padding: 0 !important;
}

.modal-margin {
  margin-top: 0 !important;
}

.content-padding {
  margin-top: 0 !important;
}

.iframe-modal {
  padding: 20px !important;
}

.footer-bg {
  background-color: #F9FAFB !important;
}
</style>
